import { render, staticRenderFns } from "./ClubPlayerPeriodStatistics.vue?vue&type=template&id=213a4a69&scoped=true"
import script from "./ClubPlayerPeriodStatistics.vue?vue&type=script&lang=js"
export * from "./ClubPlayerPeriodStatistics.vue?vue&type=script&lang=js"
import style0 from "./ClubPlayerPeriodStatistics.vue?vue&type=style&index=0&id=213a4a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a4a69",
  null
  
)

export default component.exports